import { UPDATE_PRODUCT, CLEAR_PRODUCTS, UPLOAD_ERROR, CLEAR_ERROR } from './product.action';
import { UiProduct } from '@whiz-cart/node-shared/models/product/uiProduct';

type ProductReducerParam =
    | {
          type: typeof UPLOAD_ERROR;
          payload: string;
      }
    | {
          type: typeof CLEAR_ERROR;
          payload: undefined;
      }
    | {
          type: typeof CLEAR_PRODUCTS;
          payload: undefined;
      }
    | {
          type: typeof UPDATE_PRODUCT;
          payload: {
              gtin: string;
              product: Partial<UiProduct & { unknown?: boolean; imageUrl?: string; mhdGroup?: string }>;
          }[];
      };

export default (state: Record<string, any> & { error?: string | boolean } = { error: false }, { type, payload }: ProductReducerParam) => {
    switch (type) {
        case UPDATE_PRODUCT:
            return (payload as { gtin: string; product: any }[]).reduce(
                (state, { gtin, product }) => {
                    state[gtin] = { ...state[gtin], ...product };
                    return state;
                },
                { ...state },
            );

        case CLEAR_PRODUCTS:
            return {};

        case UPLOAD_ERROR:
            return { ...state, error: payload };

        case CLEAR_ERROR:
            return { ...state, error: false };

        default:
            return state;
    }
};
